module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/EllipsisGrey-5ff516e76dee1e7674ad3c2cef97a780.png";